<!-- SPDX-License-Identifier: LicenseRef-MMS-WIRE -->
<!-- Copyright (c) 2016-2026 Metal Management Solutions (Pty) Ltd -->

@if (item) {
  <mat-list-item
    [ngClass]="{'parent':item.top===true}">
    <div class='pull-left'>
      <i (click)="getChildren(item);" [ngClass]="{'chevron-up': item.expanded , 'chevron-down' : !item.expanded }"
      class="chevron-down" role="button"></i>
      <span (click)="getChildren(item);">{{item.name}}</span>
      <div [matMenuTriggerFor]="menu"><b class="plant-menu-icon"></b></div>
    </div>
    <mat-menu #menu="matMenu" class="tree-node-menu">
      @for (entry of menu_entries; track entry) {
        <a (click)="entry.action()"
          [routerLink]="entry.link"
          [textContent]="entry.name"
        mat-menu-item></a>
      }
      <!--TODO disabling this until the component has been migrated-->
      <!--<button mat-menu-item ><a routerLink="{{'/view/calculation_graph_view/' + item.id }}" >-->
      <!--Calculation Tree-->
    <!--</a></button>-->
  </mat-menu>
  @if (loadingChildren===item.id) {
    <div class="stage">
      <div class="dot-flashing"></div>
    </div>
  }
</mat-list-item>
@if (item.expanded) {
  <mat-list [hidden]="!item.expanded" flex>
    @for (childItem of item.children; track childItem) {
      <treenode [item]="appScope.processTreeDataDict[childItem]" class="process-child-node"></treenode>
    }
  </mat-list>
}
}
